import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fixed top-0 left-0 z-50 w-screen h-screen flex items-center justify-center",
  style: {"background":"rgba(0, 0, 0, 0.6)"}
}
const _hoisted_2 = { class: "relative p-4 w-full max-w-md h-full md:h-auto" }
const _hoisted_3 = { class: "relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5" }
const _hoisted_4 = { class: "flex justify-center items-center space-x-4" }

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  emits: ['cancel', 'confirm'],
  setup(__props, { emit: __emit }) {

const emit = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel'))),
          class: "text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            "aria-hidden": "true",
            class: "w-5 h-5",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
              "clip-rule": "evenodd"
            })
          ], -1),
          _createElementVNode("span", { class: "sr-only" }, "Close modal", -1)
        ])),
        _cache[4] || (_cache[4] = _createElementVNode("svg", {
          class: "text-gray-400 dark:text-gray-500 w-11 h-11 mb-3.5 mx-auto",
          "aria-hidden": "true",
          fill: "currentColor",
          viewBox: "0 0 20 20",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
            "clip-rule": "evenodd"
          })
        ], -1)),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mb-4 text-gray-500 dark:text-gray-300" }, "Are you sure you want to delete this item?", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel'))),
            class: "py-2 px-3 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-primary-300 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
          }, " No, cancel "),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('confirm'))),
            class: "py-2 px-3 text-sm font-medium text-center text-white bg-red-600 rounded-lg hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-500 dark:hover:bg-red-600 dark:focus:ring-red-900"
          }, " Yes, I'm sure ")
        ])
      ])
    ])
  ]))
}
}

})